// Public player for the setup videos linked from invite emails. Invitees
// arrive here before they have an account, so this page needs no sign-in.

import { useParams } from 'react-router-dom';
import { API_BASE } from '../api/client';
import BrandLogo from '../components/BrandLogo';

const VIDEOS: Record<string, { title: string; next: string }> = {
  'guest-setup': {
    title: 'App Setup Video',
    next: 'When you’re done, go back to your invitation email and tap “Create Your Guest Profile.”',
  },
  'member-setup': {
    title: 'App Setup Video',
    next: 'When you’re done, go back to your invitation email and tap “Complete Your Membership Registration.”',
  },
};

export default function WatchVideo() {
  const { slug = '' } = useParams();
  const video = VIDEOS[slug];

  return (
    <div className="standalone-screen">
      <header className="bg-navy text-white">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center">
          <BrandLogo variant="white" className="h-10 w-10" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {video ? (
          <>
            <h1 className="text-2xl font-bold text-navy mb-4">{video.title}</h1>
            <video
              className="w-full rounded-xl bg-black shadow-sm"
              src={`${API_BASE}/users/invite-videos/${slug}/`}
              poster="/videos/invite-poster.jpg"
              controls
              playsInline
              preload="metadata"
            />
            <p className="mt-4 text-gray-700">{video.next}</p>
          </>
        ) : (
          <p className="text-gray-700">This video isn’t available. Check the link in your invitation email.</p>
        )}
      </main>
    </div>
  );
}
